import React, {
  useState,
  useEffect,
  useCallback,
  useMemo,
  useRef,
} from 'react';

import api from '~/services/api';

import { isArray } from 'lodash';

import { toast } from 'react-toastify';

import PropTypes from 'prop-types';
import moment from 'moment';
import { useSelector } from 'react-redux';

import { t, number } from '~/helpers';

import { Form } from '~/components/Form';

import { UnidataTable, Table } from '~/components';

import { recordFiltering } from '~/store/modules/servicedlgrelestoque/actions';

export default function FormRelTela({ params, sending, close }) {

  const [loading, setLoading] = useState(false);

  const [details, setDetails] = useState([]);

  const formRef = useRef(null);

  const data = useSelector((state) => state.servicedlgrelestoque);

  useEffect(() => {
    if (params) {

      handleGetEstoqueTotal();

      formRef.current.setData({ ...params });
    }
  }, [params]);


  const handleSubmit = useCallback(
    async (dataForm) => {
      try {
      } catch (err) {
      }
    },
    [params]
  );

  useEffect(() => {
    if (sending) formRef.current.submitForm();
  }, [sending]);

  const header = useMemo(() => [
    {
      id: 'resp',
      label: 'Responsável',
      filter: {
        type: 'text',
      },
    },
    {
      id: 'post_desc',
      label: 'Posto',
      filter: {
        type: 'text',
      },
    },
    {
      id: 'potr_data_trans',
      label: 'Última Transmissão',
      formatted: (value) => (value !== null ? moment(value).format('DD/MM/YYYY HH:mm') : '-'),
      align: 'left',

    },
    {
      id: 'tavi_capacidade',
      label: 'Capacidade Tanque',
      align: 'right',
      formatted: (value) => number(value, 1),
    },
    {
      id: 'tavi_vol',
      label: 'Estoque Tanque',
      align: 'right',
      formatted: (value) => number(value, 1),
    },

    {
      id: 'qtd',
      label: 'Qde Pátio',
      align: 'right',
      formatted: (value) => number(value, 1),
    },
    {
      id: 'volume',
      label: 'Volume Pátio',
      align: 'right',
      formatted: (value) => number(value, 1),
    },

    {
      id: 'total',
      label: 'Estoque no Posto Total',
      align: 'right',
      formatted: (value) => number(value, 1),
    },

    {
      id: 'C_StatusLinha',
      label: 'Status Transmissão Central',
      styled: (v) => (v === 'Transmissão Atrasada' ? { color: 'red' } : { color: 'green' }),
    },
  ], []);

  const headerDetais = useMemo(
    () => [
      { id: 'responsavel', label: 'Estoque', align: 'center' },
      { id: 'volumeestoque', label: 'Tanque Estoque Total', format: (value) => number(value, 1), align: 'right' },
      { id: 'volumepatio', label: 'Pátio Volume Total', format: (value) => number(value, 1), align: 'right' },
      { id: 'estoquetotal', label: 'Estoque no Posto Total', format: (value) => number(value, 1), align: 'right' },
    ],
    []
  );


  // useEffect(async () => {
  //   try {
  //     setLoading(true);
  //     //setActive({ orga_codigo, unid_codigo });

  //     const response = await api.get(
  //       `servicedlgrelestoque/getestoquetotal`
  //     );
  //     setDetails(response.data);
  //   } catch (err) {
  //     if (isArray(err)) err.map((e) => toast.error(t(e)));
  //     else toast.error(t(err));
  //   } finally {
  //     setLoading(false);
  //   }
  // }, []);


  const handleGetEstoqueTotal = useCallback(
    async () => {
      try {
        setLoading(true);       //setActive({ orga_codigo, unid_codigo });

        const response = await api.get(
          `servicedlgrelestoque/getestoquetotal`
        );
        setDetails(response.data);
      } catch (err) {
        if (isArray(err)) err.map((e) => toast.error(t(e)));
        else toast.error(t(err));
      } finally {
        setLoading(false);
      }
    },
    []
  );


  return (
    <>
      {/* {JSON.stringify(params)} */}

      {(params) &&
        <Form ref={formRef} onSubmit={handleSubmit} initialData={params}>
        </Form>
      }

      <Table
        loading={loading}
        cells={headerDetais}
        data={details}
        size="small"
        showPagination={false}
      />

      <UnidataTable
        dense
        fixed
        //maxHeight={300}
        maxHeight={`${window.innerHeight - 360}px`}
        create={false}
        update={false}
        delete={false}
        header={header}
        redux={data}
        read={recordFiltering}
        detach="veic_placa"
        keys="veic_placa"

      />
    </>
  );
}

FormRelTela.propTypes = {
  params: PropTypes.objectOf(PropTypes.any).isRequired
}
